import { useEffect } from 'react';

const SITE = 'https://daien.pl';

export interface SeoInput {
  /** Pelny tytul zakladki (bez sufiksu - podaj kompletny). */
  title: string;
  /** Meta description 140-160 znakow, po polsku, z polskimi znakami, bez em-dashy. */
  description: string;
  /** Sciezka kanoniczna zaczynajaca sie od "/", np. "/uslugi" albo "/blog/slug". */
  path: string;
  /** Absolutny lub wzgledny URL obrazka OG (opcjonalnie). */
  image?: string;
  /** Domyslnie false. true -> robots noindex,nofollow (np. 404). */
  noindex?: boolean;
  /** Domyslnie 'website'. Dla wpisow bloga ustaw 'article'. */
  ogType?: 'website' | 'article';
}

function setMeta(selector: string, attr: 'content' | 'href', value: string) {
  const el = document.head.querySelector(selector) as HTMLElement | null;
  if (el) el.setAttribute(attr, value);
}

/** Ustawia per-route SEO head. Wywolaj raz na gorze komponentu strony. */
export function useSeo({ title, description, path, image, noindex = false, ogType = 'website' }: SeoInput) {
  useEffect(() => {
    const url = `${SITE}${path}`;
    const img = image ? (image.startsWith('http') ? image : `${SITE}${image}`) : `${SITE}/og-image.jpg`;

    document.title = title;
    setMeta('meta[name="title"]', 'content', title);
    setMeta('meta[name="description"]', 'content', description);
    setMeta('link[rel="canonical"]', 'href', url);
    setMeta('meta[name="robots"]', 'content', noindex
      ? 'noindex, nofollow'
      : 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1');

    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[property="og:image"]', 'content', img);
    setMeta('meta[property="og:type"]', 'content', ogType);

    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:url"]', 'content', url);
    setMeta('meta[name="twitter:image"]', 'content', img);
  }, [title, description, path, image, noindex, ogType]);
}
